import { ComponentProps } from 'react';
import type { POISearchResult } from '@alltrails/types/AlgoliaResults';
import PaddingAwarePopup from '../../PaddingAwarePopup/PaddingAwarePopup';
import { getPOIPopupOffset } from './getPOIPopupOffset';
import POIPopupCard from './POIPopupCard';

type POIPopupProps = {
  coordinates?: [number, number];
  getPOIUrl?: (poi: POISearchResult) => string;
  hasLocationsManagePermission?: boolean;
  onClick?: (poi: POISearchResult) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onPOICardViewed?: ComponentProps<typeof POIPopupCard>['onPOICardViewed'];
  poi: POISearchResult;
};

/**
 * The card displayed when a POI is hovered on the map.
 * This is only displayed on the root explore, hence the offset only accounting for 'xs' POI pins.
 */
const POIPopup = ({
  coordinates,
  getPOIUrl,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onPOICardViewed,
  poi,
  hasLocationsManagePermission
}: POIPopupProps) => {
  const { _geoloc, photos_count } = poi;
  const poiUrl = getPOIUrl?.(poi);

  return (
    <PaddingAwarePopup
      closeButton={false}
      closeOnClick={false}
      focusAfterOpen={false}
      latitude={coordinates?.[1] ?? _geoloc!.lat}
      longitude={coordinates?.[0] ?? _geoloc!.lng}
      maxWidth="327"
      offset={getPOIPopupOffset(!!photos_count)}
    >
      <POIPopupCard
        href={poiUrl}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onPOICardViewed={onPOICardViewed}
        poi={poi}
        hasLocationsManagePermission={hasLocationsManagePermission}
      />
    </PaddingAwarePopup>
  );
};

export default POIPopup;
